import { type useContactFormApiPostMutation } from './api/swr/useContactFormApiPostMutation'
import { type ContactFormState } from './contactFormMakeContactFormState'
import { serializeModelToRequestPayload } from './contactFormSerializeModelToRequestPayload'

export const contactFormHandleContactFormSubmit = async (
  formState: ContactFormState,
  submitMutation: ReturnType<typeof useContactFormApiPostMutation>,
  setFormWasSubmittedWithSuccess: (value: boolean) => void,
): Promise<void> => {
  if (submitMutation.isMutating) {
    return
  }
  if (!formState.isValid({ validate: true })) {
    return
  }

  const payload = serializeModelToRequestPayload(formState.model)
  try {
    await submitMutation.trigger(payload)
    setFormWasSubmittedWithSuccess(true)
  } catch {
    // void -- error will be handled in component
  }
}
